export default "__VITE_IMAGE_ASSET__c841307e__";